
<app-plan-template-list planType="Fitness" title="Templates" i18n-title="@@Templates" [publicOnly]="false"
  [readonly]="false">
</app-plan-template-list>
<app-plan-template-list planType="Fitness" title="Public Templates" i18n-title="@@PublicTemplates" [publicOnly]="true"
  [readonly]="true">
</app-plan-template-list>
